/**
 * Stock market themed easter egg icons.
 * Sprinkled throughout the UI for personality.
 */

export const Bull = ({ className = "w-5 h-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M2 7.5C2 7.5 3 4 5 4C6 4 6.5 5 7 6C7.5 5 8 4 9 4C10 4 10.5 5 11 6L12 8L13 6C13.5 5 14 4 15 4C16 4 16.5 5 17 6C17.5 5 18 4 19 4C21 4 22 7.5 22 7.5L20 9C20 9 19.5 11 18 12L16 13.5V18C16 18 15 20 12 20C9 20 8 18 8 18V13.5L6 12C4.5 11 4 9 4 9L2 7.5Z" />
  </svg>
);

export const Bear = ({ className = "w-5 h-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <circle cx="7" cy="5" r="2.5" />
    <circle cx="17" cy="5" r="2.5" />
    <ellipse cx="12" cy="13" rx="7" ry="8" />
    <circle cx="9.5" cy="11" r="1" fill="white" />
    <circle cx="14.5" cy="11" r="1" fill="white" />
    <ellipse cx="12" cy="14.5" rx="2" ry="1.5" fill="white" opacity="0.6" />
  </svg>
);

export const Rocket = ({ className = "w-5 h-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C12 2 8 6 8 12C8 14 8.5 15.5 9 17L7 19L8.5 20.5L10 19C10.5 19.5 11 20 12 20C13 20 13.5 19.5 14 19L15.5 20.5L17 19L15 17C15.5 15.5 16 14 16 12C16 6 12 2 12 2ZM10.5 12C10.5 12 10.5 11 12 9C13.5 11 13.5 12 13.5 12C13.5 13 12.8 13.5 12 13.5C11.2 13.5 10.5 13 10.5 12Z" />
    <path d="M9 20L8 22H10L9 20Z" opacity="0.7" />
    <path d="M15 20L14 22H16L15 20Z" opacity="0.7" />
    <path d="M12 20L11 23H13L12 20Z" opacity="0.5" />
  </svg>
);

export const ChartUp = ({ className = "w-5 h-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 17 9 11 13 15 21 7" />
    <polyline points="17 7 21 7 21 11" />
  </svg>
);

export const ChartDown = ({ className = "w-5 h-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 7 9 13 13 9 21 17" />
    <polyline points="17 17 21 17 21 13" />
  </svg>
);

export const Diamond = ({ className = "w-5 h-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M6 3H18L22 9L12 21L2 9L6 3Z" />
    <path d="M2 9H22" fill="none" stroke="white" strokeWidth="0.5" opacity="0.4" />
    <path d="M12 21L8 9L10 3" fill="none" stroke="white" strokeWidth="0.5" opacity="0.3" />
    <path d="M12 21L16 9L14 3" fill="none" stroke="white" strokeWidth="0.5" opacity="0.3" />
  </svg>
);

export const MoneyPrinter = ({ className = "w-5 h-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <rect x="3" y="8" width="18" height="10" rx="2" />
    <rect x="6" y="4" width="12" height="5" rx="1" fill="currentColor" opacity="0.5" />
    <rect x="7" y="13" width="10" height="3" rx="1" fill="white" opacity="0.3" />
    <text x="12" y="15.5" textAnchor="middle" fontSize="3" fill="white" fontWeight="bold" opacity="0.5">$$$</text>
    <rect x="8" y="18" width="3" height="4" rx="0.5" opacity="0.4" />
    <rect x="13" y="18" width="3" height="4" rx="0.5" opacity="0.4" />
  </svg>
);

export const Candlestick = ({ className = "w-5 h-5", bullish = true }: { className?: string; bullish?: boolean }) => (
  <svg className={className} viewBox="0 0 24 24">
    {/* Left candle */}
    <line x1="6" y1="3" x2="6" y2="7" stroke="currentColor" strokeWidth="1.5" />
    <rect x="3.5" y="7" width="5" height="6" rx="0.5" fill={bullish ? "#5DC6C2" : "#FF7B7F"} stroke="currentColor" strokeWidth="1" />
    <line x1="6" y1="13" x2="6" y2="17" stroke="currentColor" strokeWidth="1.5" />
    {/* Right candle */}
    <line x1="18" y1="5" x2="18" y2="9" stroke="currentColor" strokeWidth="1.5" />
    <rect x="15.5" y="9" width="5" height="5" rx="0.5" fill={bullish ? "#5DC6C2" : "#FF7B7F"} stroke="currentColor" strokeWidth="1" />
    <line x1="18" y1="14" x2="18" y2="19" stroke="currentColor" strokeWidth="1.5" />
    {/* Middle candle */}
    <line x1="12" y1="2" x2="12" y2="6" stroke="currentColor" strokeWidth="1.5" />
    <rect x="9.5" y="6" width="5" height="8" rx="0.5" fill={bullish ? "#5DC6C2" : "#FF7B7F"} stroke="currentColor" strokeWidth="1" />
    <line x1="12" y1="14" x2="12" y2="21" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const Coin = ({ className = "w-5 h-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <circle cx="12" cy="12" r="10" />
    <circle cx="12" cy="12" r="8" fill="none" stroke="white" strokeWidth="0.5" opacity="0.3" />
    <text x="12" y="16" textAnchor="middle" fontSize="10" fill="white" fontWeight="bold" opacity="0.5">$</text>
  </svg>
);

export const SafeVault = ({ className = "w-5 h-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <rect x="2" y="3" width="20" height="17" rx="2" />
    <circle cx="12" cy="11.5" r="5" fill="none" stroke="white" strokeWidth="1.5" opacity="0.4" />
    <circle cx="12" cy="11.5" r="1.5" fill="white" opacity="0.4" />
    <line x1="12" y1="6.5" x2="12" y2="9" stroke="white" strokeWidth="1" opacity="0.3" />
    <line x1="12" y1="14" x2="12" y2="16.5" stroke="white" strokeWidth="1" opacity="0.3" />
    <line x1="7" y1="11.5" x2="9.5" y2="11.5" stroke="white" strokeWidth="1" opacity="0.3" />
    <line x1="14.5" y1="11.5" x2="17" y2="11.5" stroke="white" strokeWidth="1" opacity="0.3" />
    <rect x="19" y="10" width="2" height="3" rx="0.5" opacity="0.7" />
    <rect x="5" y="20" width="4" height="2" rx="0.5" opacity="0.5" />
    <rect x="15" y="20" width="4" height="2" rx="0.5" opacity="0.5" />
  </svg>
);

export const TickerTape = ({ className = "w-5 h-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
    <rect x="1" y="8" width="22" height="8" rx="1" fill="currentColor" opacity="0.1" stroke="currentColor" />
    <polyline points="3 14 5 10 7 13 9 9 11 12 13 10 15 14 17 11 19 13 21 10" strokeWidth="1.5" />
  </svg>
);

export const Moon = ({ className = "w-5 h-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
  </svg>
);
